module.exports = __webpack_public_path__ + "static/media/afghan-map.da589891.svg";